import {Moment} from 'moment';
import {List} from 'immutable';

import {IDischargeDataItem} from './data-list/discharge-data-list.controller';
import {IDischargeModel} from '../api/api.types';
import {IDischargeCurveFittingService} from './discharge.types';

export interface IModelCreatorService {
  createModel(newModelOptions:INewModelOptions):IDischargeModel;
  validateOptions(newModelOptions:INewModelOptions):boolean;
}

export interface INewModelOptions {
  name:string;
  date:Moment;
  creationMode:'deltaH'|'fitCurve';
  referenceModel?:IDischargeModel;
  deltaH?:number;
  selectedDischargeDataItems:List<IDischargeDataItem>;
}


export default class ModelCreatorService implements IModelCreatorService {
  static $inject = ['dischargeCurveFittingService'];

  constructor(private dischargeCurveFittingService:IDischargeCurveFittingService) {
  }

  createModel(newModelOptions:INewModelOptions):IDischargeModel {
    const dischargeModelBase:IDischargeModel = {
      id: -1,
      modelName: newModelOptions.name,
      validFrom: newModelOptions.date.clone().unix(),
      paramA: 0,
      paramB: 0,
      paramC: 0,
      paramDeltaLevel: 0
    };
    switch (newModelOptions.creationMode) {
      case 'deltaH':
        dischargeModelBase.paramA =
            newModelOptions.referenceModel.paramA + newModelOptions.deltaH;
        dischargeModelBase.paramB = newModelOptions.referenceModel.paramB;
        dischargeModelBase.paramC = newModelOptions.referenceModel.paramC;
        dischargeModelBase.paramDeltaLevel =
            newModelOptions.referenceModel.paramDeltaLevel;
        break;
      case 'fitCurve':
        const modelFit = this.dischargeCurveFittingService
            .fitCurveQuadraticMethod(
                newModelOptions.selectedDischargeDataItems.toArray());
        dischargeModelBase.paramA = modelFit.paramA;
        dischargeModelBase.paramB = modelFit.paramB;
        dischargeModelBase.paramC = modelFit.paramC;
        dischargeModelBase.paramDeltaLevel = modelFit.paramDeltaLevel;
        break;
    }
    return dischargeModelBase;
  }

  validateOptions(newModelOptions:INewModelOptions) {
    switch (newModelOptions.creationMode) {
      case 'deltaH':
        return newModelOptions.name != null &&
            newModelOptions.deltaH != null &&
            newModelOptions.referenceModel != null;
      case 'fitCurve':
        return newModelOptions.selectedDischargeDataItems.size >= 2 &&
            newModelOptions.name != null;
      default:
        return false;
    }
  }
}



/** WEBPACK FOOTER **
 ** ./app/discharge/model-creator.service.ts
 **/